export default __webpack_public_path__ + "static/media/connecting.5b935736.gif";